<survey-status
  icon="link"
  translationKey="identityRequired"
  fallbackText="Use the link from your invitation"
></survey-status>
